// Loads the Google Maps JavaScript API (with Places) once, and only when
// called. Callers check consent first; nothing here runs on page load.

const SCRIPT_ID = "google-maps-js";
let loading: Promise<void> | null = null;

export const isGoogleMapsLoaded = (): boolean =>
  typeof window !== "undefined" && !!(window as any).google?.maps?.places;

export const loadGoogleMaps = (
  apiKey: string = process.env.REACT_APP_MAPS_API_KEY || ""
): Promise<void> => {
  if (isGoogleMapsLoaded()) return Promise.resolve();
  if (loading) return loading;

  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey
    )}&libraries=places`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loading = null;
      script.remove();
      reject(new Error("Google Maps could not be loaded"));
    };
    document.head.appendChild(script);
  });
  return loading;
};

// For tests only.
export const resetGoogleMapsLoader = (): void => {
  loading = null;
  document.getElementById(SCRIPT_ID)?.remove();
};
